import List from "./list/BalanceList";
import IndividualIncom from "./list/income/individual";
import IndividualCost from "./list/cost/individual";

export default { List, IndividualIncom, IndividualCost };
